import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import type { FC, PropsWithChildren } from 'react'
import { styles } from './styles'
import type { DrawerBoxProps } from './types'
import { DrawerHeader, DrawerFooter } from './components'

export const DrawerBox: FC<PropsWithChildren<DrawerBoxProps>> = (props) => {
  const {
    title,
    subtitle,
    opened,
    onClose,
    children,
    width = 362,
    bottom,
  } = props

  return (
    <Drawer anchor={'right'} open={opened} onClose={onClose}>
      <Box sx={{ ...styles.root, width: width + 'px' }}>
        <DrawerHeader>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="h4"
              component="h4"
              sx={{
                fontWeight: 500,
                fontSize: '20px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '24ch',
              }}
            >
              {title}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          {subtitle && (
            <Typography
              component={'h4'}
              fontSize={'14px'}
              color={'#787878'}
              mt={3}
              mb={1.5}
            >
              {subtitle}
            </Typography>
          )}
        </DrawerHeader>
        <Box sx={{ ...styles.box, ...(bottom && styles.isBottom) }}>
          {children}
        </Box>
        {bottom ? <DrawerFooter>{bottom}</DrawerFooter> : null}
      </Box>
    </Drawer>
  )
}
